// lbl.home
export const home = {
    title: "สวัสดี โลก!",
    redeemable: "Redeemable remains x{0}",
};
